import { ADMIN_TYPE } from "@/enum";

export default [
  {
    path: "/airports",
    meta: {
      requiresAuth: true,
      permission: null,
      title: "Aeropuertos",
      layout: "admin",
      module: "airports",
      icon: "mdi-airport",
      notBreadCrumb: true,
      roles: [ADMIN_TYPE.RIDERY]
    },
    component: () =>
      import(
        /* webpackChunkName: "AirportsLayout" */ "@/views/airports/AirportsLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "airport-list",
        meta: {
          requiresAuth: true,
          permission: null,
          layout: "admin",
          module: "airports",
          title: "Listado",
          adminLayoutNav: true,
          icon: "mdi-format-list-bulleted",
          notBreadCrumb: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AirportsList" */ "@/views/airports/AirportsView.vue"
          ),
      },
    ],
  },
];
